import { ReactNode } from "react";
import styles from "./TopRow.module.css";

type TopRowProps = {
  children: ReactNode;
};

function TopRow({ children }: TopRowProps) {
  return <div className={styles["root"]}>{children}</div>;
}

export default TopRow;
